import React, {
  Component
} from 'react';
import * as Config from '../config/Config';
import * as User from '../helpers/User';
import {
  getUserData,
  reactLoader,
  getTokenData,
  composcroll,
  contentResizeLoad,
  message,
  scrollToTop,
  showLargeLeftMenu,
  hideleftbar,
  objToSlashString,
  CKsettings,
  showSmallLeftMenu,
  toTimestamp,
  ratings,
  ObserverEcoachMessage
} from '../helpers/Common';
import Flowplayer from '../components/Flowplayer';
import CKEditor from 'react-ckeditor-wrapper';
import AssessementViewList from './partials/AssessementViewList';
import SelectLearnerObserver from './partials/SelectLearnerObserver';
import ThanksMessage from './partials/ThanksMessage';
import TimerCountDown from '../components/TimerCountDown';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getLearningRoom} from '../actions/learningRoomAction';
import {getActiongoalAction} from '../actions/actiongoalAction';

const $=window.$;


class Descriptivetask3 extends Component {

  constructor(props) {
    super(props);

    this.state = {
     observerViewBlock:"none",
     Dt3ViewBlock:"none",
     AssessementViewData:[],
     LearningCompletedStatus:null,
     dtAnswerBlock:'none',
     dt3Answer:[],
     front_image_A:'',
     front_image_B:'',
     front_image_C:'',
     reportText_A:'',
     reportText_B:'',
     reportText_C:'',
     Rating:"",
     dt3Data:[],
     reportbtn:'block',
     reportBlock_A:'none',
     reportBlock_B:'none',
     reportBlock_C:'none',
     insttypeOption:[],
     insttypeOption_A:'',
     insttypeOption_B:'',
     insttypeOption_C:'',
     greaterdate:'',
     removeImage_A:'',
     removeImage_B:'',
     removeImage_C:'',
     instructionBlockB:'none',
     instructionBlockA:'none',
     instructionBlockC:'none',
     isMentorCheck:false,
     OBmessage:"",
     DT3status:0,
     timeForCompletion: 0,
     timerSeconds: 0
    };

    this.submitObserverandProceed=this.submitObserverandProceed.bind(this);
  }

  onChangeCKEditor(name,value){
     this.setState({
       [name]:value
     });
   }

   getAssess(){
     const {data}=this.props;
     reactLoader("show", "Please wait...");

     let query_data=objToSlashString({

      learner_id:User.UserId(),
      seq_id:data.compseq_id,
      lroom_id:data.learning_room_id,
      dlr_id:data.dlr_id,
      comp_id:data.id,
      type:'dt3'

     });

     fetch(Config.domainUrl+'mentor-assess/view'+query_data, {
       method: 'GET',
       headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json',
         'Authorization':'Bearer ' +getTokenData()
       }
     }).then((response) => response.json()).then((responseJson) => {

      if(responseJson.status===1){

        this.setState({AssessementViewData:responseJson.data});
      }

       reactLoader("hide");
     });
   }

   getdt3Answer(){
     const {data}=this.props;
     reactLoader("show", "Please wait...");

     let query_data=objToSlashString({

      learner_id:User.UserId(),
      comp_id:data.id,
      lroom_id:data.learning_room_id,
      dlr_id:data.dlr_id,
      seq_id:data.compseq_id
     });

     fetch(Config.domainUrl+'descriptive-task3-answer/view'+query_data+'?expand=report_file_a,report_file_b,report_file_c', {
       method: 'GET',
       headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json',
         'Authorization':'Bearer ' +getTokenData()
       }
     }).then((response) => response.json()).then((responseJson) => {

      if(responseJson.status===1){

       let instructionBlockA="none";
       let instructionBlockB="none";
       let instructionBlockC="none";

         let instruction_type=responseJson.data.instruction_type.split(",");

         
         if(instruction_type.length>0){
           instruction_type.map((key,i)=>{
             if(key==='a'){
                instructionBlockA="block";
             }
             if(key==='b'){
                instructionBlockB="block";
             }
             if(key==='c'){
                instructionBlockC="block";
             }
           })
         }

         this.setState({
          reportbtn:"none",
          instructionBlockA:instructionBlockA,
          instructionBlockB:instructionBlockB,
          instructionBlockC:instructionBlockC,
          dt3Answer:responseJson.data,
          DT3status:1
         });
         
      }

       reactLoader("hide");
     });
   }

  getDt3(id){
    reactLoader("show", "Please wait...");
   	fetch(Config.domainUrl+'descriptive-task3/'+id+'?expand=validity_date', {
     	method: 'GET',
     	headers: {
     		'Accept': 'application/json',
       	'Content-Type': 'application/json',
         'Authorization':'Bearer ' +getTokenData()
     	}
   	}).then((response) => response.json()).then((responseJson) => {
      let dt3=responseJson.data;

     let greaterdate=getUserData("specialExpiryDate", true);
     let expiryDate=getUserData("specialExpiryDate", true).split("-");

     let newExpiryDate=new Date(expiryDate[0]+"/"+expiryDate[1]+"/"+expiryDate[2]);

      if(dt3.submitlater_due>0){
        if(dt3.validity_date.timestamp<toTimestamp(newExpiryDate)){
         greaterdate=dt3.validity_date.display;
        }

      }

      let isMentor=true;
      if(dt3.evaluation_mentor===0){
        isMentor=false;
      }

      let ObEcoObj={
       evaluation_mentor:dt3.evaluation_mentor,
       evaluation_ecoach:dt3.evaluation_ecoach,
       mentor_perform:dt3.mentor_perform,
       ecoach_perform:dt3.ecoach_perform,
       mentor_view:dt3.mentor_view,
       ecoach_view:dt3.ecoach_view
      };

     let dt3message=ObserverEcoachMessage(ObEcoObj);

     this.setState({
      dt3Data:dt3,
      greaterdate:greaterdate,
      isMentorCheck:isMentor,
      OBmessage:dt3message,
      timeForCompletion:dt3.total_duration,
      timerSeconds:(dt3.total_duration* 60)
     });

     this.getLearningCompletedStatus();
     this.getAssess();
     this.switchBlock();


      composcroll();
      contentResizeLoad();
      showSmallLeftMenu();
   		 reactLoader("hide");
   	});
  }

  getLearningCompletedStatus(){
    const {data}=this.props;
    reactLoader("show", "Please wait...");

    let query_data=objToSlashString({

     learner_id:User.UserId(),
     compseq_id:data.compseq_id,
     lroom_id:data.learning_room_id,
     dlr_id:data.dlr_id
    });

    fetch(Config.domainUrl+'learner-component-status/view'+query_data+'?expand=completed_date,Cscore', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization':'Bearer ' +getTokenData()
      }
    }).then((response) => response.json()).then((responseJson) => {

      if(responseJson.status===1){
        this.setState({
         LearningCompletedStatus:responseJson.data
        });
      }

      reactLoader("hide");
    });
  }

  handleImageAllChange(e,name){

   //console.log(e);
   //console.log(name);

   if(this.refs[name].files[0]!==undefined){
    let suffix=name.split("_");
   var reader = new FileReader();
         let self=this;
         let removeAnchor=<a href="javascript:void(0);" onClick={(e)=>self.removeImage(name)} style={{color:'#ff0000',textDecoration: 'underline'}}>X Remove Attachment</a>;

         reader.onload = function (e) {

            if(e.target.result.match(/image/g)){


             self.setState({['front_image_'+suffix[1]]:e.target.result,['removeImage_'+suffix[1]]:removeAnchor});
            }else{
             self.setState({['front_image_'+suffix[1]]:'',['removeImage_'+suffix[1]]:removeAnchor});
            }

        }

         reader.readAsDataURL(this.refs[name].files[0]);
       }
  }

  removeImage(name){
    let suffix=name.split("_");
     this.refs[name].value='';
     this.setState({['front_image_'+suffix[1]]:'',['removeImage_'+suffix[1]]:''});
  }

  instruction(e){

     if(e.target.name==='instruction'){

        let instruction =  document.querySelectorAll('input[name=instruction]');
         let instructionChecked =  document.querySelectorAll('input[name=instruction]:checked');

         for (var i = 0; i < instruction.length; i++) {

             if(instruction[i].checked===true){

                   if(instructionChecked.length>2){

                    message('Attention!','You can only select two options.','error');

                    if(instruction[i].value===e.target.value){
                      instruction[i].checked=false;
                       continue;
                    }

                   }else{


                    if(instruction[i].value==='a' && e.target.value==='a'){

                      this.setState({reportBlock_A:'block'});

                    }

                    if(instruction[i].value==='b' && e.target.value==='b'){
                      this.setState({reportBlock_B:'block'});

                    }

                    if(instruction[i].value==='c' && e.target.value==='c'){

                      this.setState({reportBlock_C:'block'})
                    }

                }

              }else{


                  if(instruction[i].value==='a' && e.target.value==='a'){

                    this.setState({reportBlock_A:'none'});

                  }

                  if(instruction[i].value==='b' && e.target.value==='b'){
                    this.setState({reportBlock_B:'none'});

                  }

                  if(instruction[i].value==='c' && e.target.value==='c'){
                    this.setState({reportBlock_C:'none'})
                  }

              }


         }

          let instructions=[];
          let newinstructionCheckedValues =  document.querySelectorAll('input[name=instruction]:checked');

          for (var j = 0; j < newinstructionCheckedValues.length; j++) {
            instructions.push(newinstructionCheckedValues[j].value);
          }

         if(instructions.length>0){
           this.setState({insttypeOption:instructions})
         }
     }

  }

  viewReportBlock(type){

     if(type==="proceed"){

        if(!this.state.insttypeOption){
           message('Attention','Please select an option to submit your report.','warning');
        }else{

          this.setState({
           reportbtn:'none'
          })
        }
     }

     if(type==="cancel"){

       this.setState({
        reportbtn:'block'
       })
     }
  }


  submitObserverandProceed(obj){

    const {data}=this.props;


     let request_data={
      comp_id:data.id,
      learner_id:User.UserId(),
      compseq_id:data.compseq_id,
      lroom_id:data.learning_room_id,
      divider_id:data.divider_id,
      dlrid:data.dlr_id,
      mentor:this.state.isMentorCheck,
      observers:obj,
      dt3Data:this.state.dt3Data,
      ag:(data.is_ag!=="")?data.ag_id:""
     };


     reactLoader("show", "Please wait...");
     fetch(Config.domainUrl+'descriptive-task3/observer-proceed', {
       method: 'POST',
       headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json',
         'Authorization':'Bearer ' +getTokenData()
       },
       body: JSON.stringify(request_data)
     }).then((response) => response.json()).then((responseJson) => {

       reactLoader("hide");
       if (responseJson.status === 2) {
        this.props.getLearningRoom();
         scrollToTop();
         if (responseJson.isCompletedFully) {
             this.goToThanksPage();
         } else {
            message(responseJson.message,'','success');
            if(this.props.usableType==="webapp"){

              this.props.switchback('component_list',data.learning_room_id,data.dlr_id);
            }
          }

       }else{
          message('','Something went wrong.','error');
       }
     });
  }
  goToThanksPage() {
      const {
          data
      } = this.props;
      this.props.returnthanks({
          "status": "completed",
          "learning_room_id": data.learning_room_id,
          "compseq_id": data.compseq_id,
          "divider_id": data.divider_id,
          "dlr_id": data.dlr_id,
          "learner_id": data.learner_id,
          "is_ag": data.is_ag,
          "id": data.id,
          "compo_type": "thanks",
          "look_before": data.compseq_id,
          "flowresult": true
      });
  }


  submitReport(){

    const {data}=this.props;

     let formData = new FormData();
     let request_data={
      instruction_type:this.state.insttypeOption,
      reportText_A:this.state.reportText_A,
      reportText_B:this.state.reportText_B,
      reportText_C:this.state.reportText_C,
      comp_id:data.id,
      learner_id:User.UserId(),
      compseq_id:data.compseq_id,
      lroom_id:data.learning_room_id,
      divider_id:data.divider_id,
      dlrid:data.dlr_id,
      mentor:this.state.isMentorCheck,
      ag:(data.is_ag!=="")?data.ag_id:""
     };


     for ( var key in request_data ) {
			    formData.append(key, request_data[key]);
			  }

     if(this.state.dt3Data.learnerefortrating===1){

       formData.append('Rating',this.state.Rating);
     }

     if(this.refs.reportfile_A.files[0]!==undefined){
			 	 formData.append('reportfile_A',this.refs.reportfile_A.files[0]);
  			}else{
  				formData.append('reportfile_A','');
  			}

     if(this.refs.reportfile_B.files[0]!==undefined){
			 	 formData.append('reportfile_B',this.refs.reportfile_B.files[0]);
  			}else{
  				formData.append('reportfile_B','');
  			}

     if(this.refs.reportfile_C.files[0]!==undefined){
			 	 formData.append('reportfile_C',this.refs.reportfile_C.files[0]);
  			}else{
  				formData.append('reportfile_C','');
  			}

     if(this.state.insttypeOption.length===0 || this.state.insttypeOption.length<2){
        message('Attention!','You have to select two options.','error');
     }else{

       reactLoader("show", "Please wait...");
       fetch(Config.domainUrl +"descriptive-task3/submit-report", {
        method: "POST",

        headers: {
         'Accept': 'application/json',
         'Authorization':'Bearer ' +getTokenData()
         // 'Content-Type': false

        },
        body: formData,
       }).then((response) => response.json()).then((responseJson) => {
        reactLoader("hide");

        if (responseJson.status === 0) {

         message(responseJson.message,responseJson.errors,'error');

        }else{

          this.props.getLearningRoom();
            scrollToTop();
            if (responseJson.isCompletedFully) {
                this.goToThanksPage();
            } else {

               if(responseJson.observerblock){

                this.setState({
                 LearningCompletedStatus:responseJson.data,
                 observerViewBlock:"block",
                 Dt3ViewBlock:"none"
                });

               }else{

                //Common.message(responseJson.message,'','success');
                //message("Submitted successfully",'','success');
                message("", "Submitted successfully.");
                this.props.switchback('component_list',data.learning_room_id,data.dlr_id);

               }
             }
        }


       });
     }


  }

  submitLater(){

   window.swal({
       // title: 'Attention!',
        text: 'Complete the Practice assigment and submit by '+this.state.greaterdate+'.',
        //type: 'question',
        //showCancelButton: true,
        confirmButtonColor: '#14a430',
        animation: false,
        //cancelButtonColor: '#d33',
        confirmButtonText: 'Ok'
      }).then((result) => {
       //console.log(result.value);
       //console.log(result.dismiss);
          if (result) {

          const {data}=this.props;

           let request_data={
            comp_id:data.id,
            learner_id:User.UserId(),
            compseq_id:data.compseq_id,
            lroom_id:data.learning_room_id,
            divider_id:data.divider_id,
            dlrid:data.dlr_id,
            due_date:this.state.greaterdate,
            ag:(data.is_ag!=="")?data.ag_id:""

           };


           reactLoader("show", "Please wait...");
           fetch(Config.domainUrl +"descriptive-task3/submit-report-later", {
            method: "POST",
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization':'Bearer ' +getTokenData()
            },
            body: JSON.stringify(request_data),
           }).then((response) => response.json()).then((responseJson) => {
            reactLoader("hide");

            if (responseJson.status === 0) {

               message(responseJson.message,responseJson.errors,'error');

            }else{
              
             // Common.message("Submitted successfully.",'','success');
              if(this.props.usableType==="webapp"){
                this.props.getLearningRoom();
                this.props.switchback('component_list',data.learning_room_id,data.dlr_id);
              }

            }


           });


       }


      });

  }

  handleChange(e){
   this.setState({[e.target.name]:e.target.value})
  }

  backToComponentList(){
    const {data}=this.props;
    this.props.switchback('component_list',data.learning_room_id,data.dlr_id);

  }

  switchBlock(){

     const {data}=this.props;

     setTimeout(()=>{



     if(data.status==="completed"){
      //console.log("completed");

        this.setState({
         observerViewBlock:"none",
         Dt3ViewBlock:"none",
         dtAnswerBlock:"block",
        
        });

     }else if(data.status==="incompleted"){



         if(this.state.isMentorCheck){
           // console.log("incompleted if");

            if(this.state.DT3status===1){

               this.setState({
                Dt3ViewBlock:"none",
                dtAnswerBlock:"none",
                observerViewBlock:"block"
               });
            }else{

               this.setState({
                Dt3ViewBlock:"block",
                dtAnswerBlock:"none",
                observerViewBlock:"none"
               });
            }
         }else{

          // console.log("incompleted else");

          //   this.setState({
          //    observerViewBlock:"none",
          //    Dt3ViewBlock:"none",
          //    dtAnswerBlock:"block"
          //   });

          if(this.state.DT3status===1){

            this.setState({
             Dt3ViewBlock:"none",
             dtAnswerBlock:"block",
             observerViewBlock:"none"
            });
         }else{

            this.setState({
             Dt3ViewBlock:"block",
             dtAnswerBlock:"none",
             observerViewBlock:"none"
            });
         }

         }
     }else{
      //  console.log("empty");
        this.setState({
         observerViewBlock:"none",
         Dt3ViewBlock:"block",
         dtAnswerBlock:"none"
        });

     }

      },400)

  }


  timeUp(){

   const {data}=this.props;

    let formData = new FormData();
    let request_data={
     instruction_type:this.state.insttypeOption,
     reportText_A:this.state.reportText_A,
     reportText_B:this.state.reportText_B,
     reportText_C:this.state.reportText_C,
     comp_id:data.id,
     learner_id:User.UserId(),
     compseq_id:data.compseq_id,
     lroom_id:data.learning_room_id,
     divider_id:data.divider_id,
     dlrid:data.dlr_id,
     mentor:this.state.isMentorCheck,
     ag:(data.is_ag!=="")?data.ag_id:""
    };


    for ( var key in request_data ) {
      formData.append(key, request_data[key]);
    }

    if(this.state.dt3Data.learnerefortrating===1){

      formData.append('Rating',this.state.Rating);
    }

    if(this.refs.reportfile_A.files[0]!==undefined){
     formData.append('reportfile_A',this.refs.reportfile_A.files[0]);
    }else{
     formData.append('reportfile_A','');
    }

    if(this.refs.reportfile_B.files[0]!==undefined){
     formData.append('reportfile_B',this.refs.reportfile_B.files[0]);
    }else{
     formData.append('reportfile_B','');
    }

    if(this.refs.reportfile_C.files[0]!==undefined){
     formData.append('reportfile_C',this.refs.reportfile_C.files[0]);
    }else{
     formData.append('reportfile_C','');
    }


    reactLoader("show", "Please wait...");
    fetch(Config.domainUrl +"descriptive-task3/submit-timeup", {
     method: "POST",

    headers: {
        'Accept': 'application/json',
        'Authorization':'Bearer ' +getTokenData()
        // 'Content-Type': false

       },
     body: formData,
    }).then((response) => response.json()).then((responseJson) => {
     reactLoader("hide");

     if (responseJson.status === 0) {

        message(responseJson.message,responseJson.errors,'error');

     }else{
       
      this.props.getLearningRoom();
       scrollToTop();
       if (responseJson.isCompletedFully) {
           this.goToThanksPage();
       } else {

           message(responseJson.message,responseJson.errorMsg,'warning');
           if(this.props.usableType==="webapp"){
            this.props.switchback('component_list',data.learning_room_id,data.dlr_id);
           }

         }

     }


    });

  }


  componentDidMount() {

    const {data}=this.props;
    this.getdt3Answer();
    this.getDt3(data.id);

    if(data.is_ag){
      this.props.getActiongoalAction(data.ag_id);     
       
    }

    setTimeout(()=>{

        $('audio').on("play", function (me) {

          $('audio').each(function (i,e) {
            if (e !== me.currentTarget) {
              this.pause();
              this.currentTime=0;
            }
          });
        });
    },500)


  }

  render() {

   const {data}=this.props;
   let dt3=this.state.dt3Data;
   let LCStatus=this.state.LearningCompletedStatus;
   let dt3Answer=this.state.dt3Answer;
   let Ratings=ratings;


   let control_style={ position:'relative',zIndex: 1};
   let video_player_a=null;
   let audio_player_a=null;
   let download_file_a=null;

   let front_image_A=null;
   let front_image_B=null;
   let front_image_C=null;

   let video_player_b=null;
   let audio_player_b=null;
   let download_file_b=null;


   let video_player_c=null;
   let audio_player_c=null;
   let download_file_c=null;


   let trackData={
  
    compseq_id: data.compseq_id,
    lroom_id: data.learning_room_id,
    divider_id: data.divider_id,
    learner_id: data.learner_id,        
    dlr_id: data.dlr_id,
    compo_type:data.compo_type
  };


   let subMitLaterButton=null;

   if(dt3.submit_later>0){

       if(LCStatus===null && data.status===""){
         subMitLaterButton=<input type="button" title="Submit Later" alt="Submit Later" className="button-cancel" value="Submit Later" id="submitlater" name="submitlater" onClick={(e)=>this.submitLater()} />;
       }

       if(LCStatus!==null){
        if(LCStatus.allow_later!==1){
          subMitLaterButton=<input type="button" title="Submit Later" alt="Submit Later" className="button-cancel" value="Submit Later" id="submitlater" name="submitlater" onClick={(e)=>this.submitLater()} />;

        }
       }

   }


   if (dt3.pa_video!==undefined) {

    if(dt3.pa_video!==''){

     

     let video_playlist={
      share:false,
      ratio: 9/16,
      clip:{
        sources: [
                {
                 
                   type: "video/mp4",
                   src:Config.rootDomainUrl+'admin/task3_video/'+dt3.pa_video
                }
               ]
      }
    };

     video_player_a=<Flowplayer key={`vplayer_0`} trackData={trackData} playlist={video_playlist} />;
    }
   }

   if (dt3.pa_video_b!==undefined) {

    if(dt3.pa_video_b!==''){
     

      let video_playlist={
        share:false,
        ratio: 9/16,
        clip:{
  
          sources: [
                  {
                   
                     type: "video/mp4",
                     src:Config.rootDomainUrl+'admin/task3_video/'+dt3.pa_video_b
                  }
                 ]
        }
      };

      video_player_b=<Flowplayer key={`vplayer_1`} trackData={trackData} playlist={video_playlist} />;
    }

   }

   if (dt3.pa_video_c!==undefined) {

    if(dt3.pa_video_c!==''){

      let video_playlist={
        share:false,
        ratio: 9/16,
        clip:{
  
          sources: [
                  {
                   
                     type: "video/mp4",
                     src:Config.rootDomainUrl+'admin/task3_video/'+dt3.pa_video_c
                  }
                 ]
        }
      };
     
      video_player_c=<Flowplayer key={`vplayer_1`} trackData={trackData} playlist={video_playlist} />;
    }

   }

   if (dt3.pa_file_name!==undefined) {

    if(dt3.pa_file_name!==''){

     download_file_a=<a href={`${Config.rootDomainUrl}admin/task3_file/${dt3.pa_file_name}`} className="redlnk" target="_blank" style={{lineHeight:'20px'}} title={`Download file`}>Download file
     </a>
    }

   }


   if (dt3.pa_audio!==undefined) {

    if(dt3.pa_audio!==''){

     audio_player_a=<audio controls style={control_style} controlsList="nodownload">
     <source src={`${Config.rootDomainUrl}admin/task3_audio/${dt3.pa_audio}`} type="audio/mpeg" width="400" height="50"/>
     </audio>;
    }

   }

   if (dt3.pa_audio_b!==undefined) {

    if(dt3.pa_audio_b!==''){

     audio_player_b=<audio controls style={control_style} controlsList="nodownload">
     <source src={`${Config.rootDomainUrl}admin/task3_audio/${dt3.pa_audio_b}`} type="audio/mpeg" width="400" height="50"/>
     </audio>;
    }

   }


   if (dt3.pa_audio_c!==undefined) {

    if(dt3.pa_audio_c!==''){

     audio_player_c=<audio controls style={control_style} controlsList="nodownload">
     <source src={`${Config.rootDomainUrl}admin/task3_audio/${dt3.pa_audio_c}`} type="audio/mpeg" width="400" height="50"/>
     </audio>;
    }

   }

   if (dt3.pa_file_name_b!==undefined) {

    if(dt3.pa_file_name_b!==''){

     download_file_b=<a href={`${Config.rootDomainUrl}admin/task3_file/${dt3.pa_file_name_b}`} className="redlnk" target="_blank" style={{lineHeight:'20px'}} title={`Download file`}>Download file
     </a>
    }


   }

   if (dt3.pa_file_name_c!==undefined) {

    if(dt3.pa_file_name_c!==''){

     download_file_c=<a href={`${Config.rootDomainUrl}admin/task3_file/${dt3.pa_file_name_c}`} className="redlnk" target="_blank" style={{lineHeight:'20px'}} title={`Download file`}>Download file
     </a>
    }


   }

   if(this.state.front_image_A!==''){
      front_image_A=<img id="front_image" src={this.state.front_image_A} width="150" />
   }
   if(this.state.front_image_B!==''){
      front_image_B=<img id="front_image" src={this.state.front_image_B} width="150" />
   }
   if(this.state.front_image_C!==''){
      front_image_C=<img id="front_image" src={this.state.front_image_C} width="150" />
   }


        let Score=null;

        if(LCStatus!==null){

           if(LCStatus.Cscore!=="" && this.state.DT3status!==0){
             Score=<div className="comp_scorePA"><strong>Score: </strong>{LCStatus.Cscore}</div>
          }

        }

     let DontShow=0;
     let AssessementViewListBlock=null;
     if(dt3.evaluation_mentor===0 && dt3.evaluation_ecoach===0){
       DontShow=1;
     }

     if(DontShow===0 && this.state.DT3status!==0 && LCStatus!==null){
      if(LCStatus.allow_later===0){

       AssessementViewListBlock=<AssessementViewList data={this.state.AssessementViewData}/>;
      }
     }

     let Timer=null;

     if(dt3.total_duration>0 && this.state.DT3status===0 && data.dlr_id){
        Timer=<TimerCountDown seconds={this.state.timerSeconds} onComplete={(e)=>this.timeUp()} />;
     }

    return (
     <div className="main-inner">
     {Timer}

     {data.is_ag!=="" &&
      <div>
        <div className="img_action_goal">
          <img src={process.env.PUBLIC_URL +"/images/img_action_goal1.gif"} width="58" height="82" alt="Action Goal" title="Action Goal" border="0" />
        </div>
        <div className="ag_title_arrow">
        {(this.props.actionGoal.ag_name!==undefined)?this.props.actionGoal.ag_name:""}
        </div><br />
      </div>
     }

      <div className="border-box">
      <div className={dt3.base_line?"title-box":"title-box tit-new"}>
         <div title={dt3.alt_text?dt3.alt_text:''} className="cw_completed_button"></div>
         <h6>{dt3.pa_name?dt3.pa_name:''}</h6><span className="bluetxt">{dt3.base_line?dt3.base_line:''}    </span>
         </div>
      <section className="scroll" id="semana-scroll-inner">

       <section className="viewport">
        <section className="overview" style={{top: '0px'}}>
         <div className="inner-content">


               <div style={{display:this.state.observerViewBlock}}>
               <ThanksMessage  message={this.state.OBmessage} />
               <SelectLearnerObserver submitObserverandProceed={this.submitObserverandProceed} />
               </div>
              <div style={{display:this.state.Dt3ViewBlock}}>

               <div className="practice-assignment" >


               {dt3.evaluation_mentor===0 &&
                <div>
                <div style={{clear:'both',height:'17px'}}></div>
                 {dt3Answer.instruction_type===undefined?<div style={{clear:'both',padding:'0px 0 10px 7px'}}>There are 3 options for this PA. Please read both and choose any two to work on.</div>:""}
                </div>
               }


               <div className="graybox">

                <div className="instruction_top">
                {dt3Answer.instruction_type===undefined?<input name="instruction" id="instruction_a" value="a" type="checkbox" onChange={(e)=>this.instruction(e)} />:""} Option A
                </div>

                 <div className="instruction_txt coursewrkvideo">
                 {video_player_a!==null &&
                  <div className="announcement testtimevideo">
                  {video_player_a}
                  </div>
                 }

                 {audio_player_a!==null &&

                  <div className="announcement testtimevideo">
                  {audio_player_a}
                  </div>

                 }

                 {download_file_a?download_file_a:''}

                 </div>


                {dt3.pa_instruction_a!=="" &&

                   <div className="comp_txt">
                   <div className="editortxt edtxttop">
                   <span className="ddcomp" dangerouslySetInnerHTML={{ __html:dt3.pa_instruction_a?dt3.pa_instruction_a:''}} />
                   </div>
                   </div>
                }

                </div>

                <div style={{display:this.state.reportBlock_A}}>
                  <div className="graybox_test">
                    <div className="PACWans">

                      <div className="tabgrey" style={{marginTop:'15px'}}>
                      <div className="mentermailrow">
                            <div className="mentermaillft">Report A</div>
                            <div className="mentermailrgt"><div lass="txtareaborder">
                            <CKEditor
                             value={this.state.reportText_A}
                             onChange={this.onChangeCKEditor.bind(this,'reportText_A')}
                             config={CKsettings}
                             />
                            </div>

                              </div>
                               </div>


                               <div className="mentermailrow">
                                <div className="mentermaillft"></div>
                                 <div className="mentermailrgt">
                                 File  <input type="file" name="reportfile_A" ref="reportfile_A"  size="80" id="reportfile" onChange={(e)=>this.handleImageAllChange(e,'reportfile_A')} />
                                  <br />
                                  {front_image_A}
                                   <br />
                                  {this.state.removeImage_A}

                                   <br />
                                   <span className="smalltextreg" style={{color:'#ff5400'}}>Max file size accepted: 5 MB (Single file)<br />
File formats accepted: PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, TXT, JPEG and PNG</span>
                                 </div>
                             </div>

                      </div>
                    </div>
                  </div>
                </div>


                <div className="or">(or)</div>



                 <div className="graybox_test">
                  <div className="instruction_top">
                  {dt3Answer.instruction_type===undefined?<input name="instruction" id="instruction_b" value="b" type="checkbox" onChange={(e)=>this.instruction(e)} />:""} Option B
                  </div>


                   <div className="instruction_txt coursewrkvideo">
                   {video_player_b!==null &&
                    <div className="announcement testtimevideo">
                    {video_player_b}
                    </div>
                   }



                   {audio_player_b!==null &&

                    <div className="announcement testtimevideo">
                    {audio_player_b}
                    </div>

                   }

                   {download_file_b?download_file_b:''}
                   </div>


                  {dt3.pa_instruction_b!=="" &&

                     <div className="comp_txt">
                     <div className="editortxt edtxttop">
                     <span className="ddcomp" dangerouslySetInnerHTML={{ __html:dt3.pa_instruction_b?dt3.pa_instruction_b:''}} />
                     </div>
                     </div>
                  }

                </div>

                  <div style={{display:this.state.reportBlock_B}}>
                    <div className="graybox_test">
                      <div className="PACWans">

                        <div className="tabgrey" style={{marginTop:'15px'}}>
                      		<div className="mentermailrow">
                             	<div className="mentermaillft">Report B</div>
                             	<div className="mentermailrgt"><div lass="txtareaborder">
                              <CKEditor
                               value={this.state.reportText_B}
                               onChange={this.onChangeCKEditor.bind(this,'reportText_B')}
                               config={CKsettings}
                               />
                              </div>

                                </div>
                                	</div>


                                 <div className="mentermailrow">
                                		<div className="mentermaillft"></div>
                                 		<div className="mentermailrgt">
                                     File  <input type="file" name="reportfile_B" ref="reportfile_B"  size="80" id="reportfile" onChange={(e)=>this.handleImageAllChange(e,'reportfile_B')} />
                                   	<br />
                                    {front_image_B}
                                    	<br />
                                    {this.state.removeImage_B}

                                    	<br />
                                    	<span className="smalltextreg" style={{color:'#ff5400'}}>Max file size accepted: 5 MB (Single file)<br />
File formats accepted: PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, TXT, JPEG and PNG</span>
                                   </div>
                               </div>


                        </div>
                      </div>
                    </div>
                  </div>



                 <div className="or">(or)</div>

                 <div className="graybox_test">
                  <div className="instruction_top">
                  {dt3Answer.instruction_type===undefined?<input name="instruction" id="instruction_c" value="c" type="checkbox" onChange={(e)=>this.instruction(e)} />:""} Option C
                  </div>


                   <div className="instruction_txt coursewrkvideo">
                   {video_player_c!==null &&
                    <div className="announcement testtimevideo">
                    {video_player_c}
                    </div>
                   }



                   {audio_player_c!==null &&

                    <div className="announcement testtimevideo">
                    {audio_player_c}
                    </div>

                   }

                   {download_file_c?download_file_c:''}
                   </div>


                  {dt3.pa_instruction_c!=="" &&

                     <div className="comp_txt">
                     <div className="editortxt edtxttop">
                     <span className="ddcomp" dangerouslySetInnerHTML={{ __html:dt3.pa_instruction_c?dt3.pa_instruction_c:''}} />
                     </div>
                     </div>
                  }
                 </div>


                  <div style={{display:this.state.reportBlock_C}}>
                    <div className="graybox_test">
                      <div className="PACWans">

                        <div className="tabgrey" style={{marginTop:'15px'}}>
                      		<div className="mentermailrow">
                             	<div className="mentermaillft">Report C</div>
                             	<div className="mentermailrgt"><div lass="txtareaborder">
                              <CKEditor
                               value={this.state.reportText_C}
                               onChange={this.onChangeCKEditor.bind(this,'reportText_C')}
                               config={CKsettings}
                               />
                              </div>

                                </div>
                                	</div>


                                 <div className="mentermailrow">
                                		<div className="mentermaillft"></div>
                                 		<div className="mentermailrgt">
                                     File  <input type="file" name="reportfile_C" ref="reportfile_C"  size="80" id="reportfile" onChange={(e)=>this.handleImageAllChange(e,'reportfile_C')} />
                                   	<br />
                                    {front_image_C}
                                    	<br />
                                    {this.state.removeImage_C}

                                    	<br />
                                    	<span className="smalltextreg" style={{color:'#ff5400'}}>Max file size accepted: 5 MB (Single file)<br />
File formats accepted: PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, TXT, JPEG and PNG</span>
                                   </div>
                               </div>


                        </div>
                      </div>
                    </div>
                  </div>




                 {dt3.learnerefortrating===1 &&
                 <div className="mentermailrow">

                    <div className="learnerratingPACW">
                    <span className="question_txt">
                      <span className="myrate">I would rate my efforts in actioning this component as <span className="redtext">*</span>
                    </span>

                     <span className="myrate-select">
                       <select name="Rating" id="Rating" value={this.state.Rating} onChange={(e)=>this.handleChange(e)} >
                           <option value="">Select</option>
                           <option value="1" >Poor ( 1 )</option>
                           <option value="2" >Below Average ( 2 )</option>
                           <option value="3" >Average ( 3 )</option>
                           <option value="4" >Above Average ( 4 )</option>
                           <option value="5" >Good ( 5 )</option>
                           <option value="6" >Excellent ( 6 )</option>
                           <option value="7" >Outstanding ( 7 )</option>
                         </select>
                       </span>
                       </span>
                    </div>

                    </div>
                   }
                  <div className="button">
                   <div className="reportbtn">
                    <input type="button" style={{float:'right'}} name="btnreport" value="Submit" onClick={(e)=>this.submitReport()} className="button-accept" alt="Submit Your Report" title="Submit Your Report" />

                    </div>
                    {subMitLaterButton}
                    </div>


                </div>

           </div>

          <div style={{display:this.state.dtAnswerBlock}}>

          {this.state.DT3status!==0 &&
            <div>
          {LCStatus!==null &&
           <div>

          {LCStatus.state!==0 &&
            <div>
          {dt3.learnerefortrating===1 &&

           <div>
           {DontShow===0?
            <div className="LERresult">
            My effort rating of this component is - <b>
            {LCStatus.self_rating?LCStatus.self_rating:0} / 7 {LCStatus.self_rating?Ratings[LCStatus.self_rating]:""}		</b>
            </div>:""
           }


            </div>
           }
           </div>
          }
          </div>
          }
          </div>
          }


          {DontShow===0?Score:""}
          <br/>
           {AssessementViewListBlock}

           <div style={{float:'left'}}>
            <div className="graybox" style={{display:this.state.instructionBlockA,float:'left'}}>
            <div className="graybox-inner">
            <div className="instruction_top">
            Option A
            </div>

             <div className="instruction_txt coursewrkvideo">
             {video_player_a!==null &&
              <div className="announcement testtimevideo">
              {video_player_a}
              </div>
             }

             {audio_player_a!==null &&

              <div className="announcement testtimevideo">
              {audio_player_a}
              </div>

             }

             {download_file_a?download_file_a:''}

             </div>


            {dt3.pa_instruction_a!=="" &&

               <div className="comp_txt">
               <div className="editortxt edtxttop">
               <span className="ddcomp" dangerouslySetInnerHTML={{ __html:dt3.pa_instruction_a?dt3.pa_instruction_a:''}} />
               </div>
               </div>
            }
           </div> 
            <div className="report-content">


                      <h3>Report A</h3>

                       <span dangerouslySetInnerHTML={{ __html:dt3Answer.option_a_answer?dt3Answer.option_a_answer:''}} />



                   {(dt3Answer.report_file_a!==null && dt3Answer.report_file_a!=="")?
                    <div className="mentermailrow">
                    <div className="mentermaillft"><h3>File</h3></div>
                    <div className="mentermailrgt">
                    <a href={`${Config.domainUrl}download/dt3_report_file/${dt3Answer.report_file_a}`} className="redlnk" target="_blank" style={{float:'left',marginTop:0}} title={`Download file`}>Download file
                    </a>
                    </div>
                    </div>:""}

           </div>

          </div>
              
            
          <div className="graybox_test" style={{display:this.state.instructionBlockB,float:'left'}}>
          <div className="graybox-inner">
           <div className="instruction_top">
            Option B
           </div>

            <div className="instruction_txt coursewrkvideo">
            {video_player_b!==null &&
             <div className="announcement testtimevideo">
             {video_player_b}
             </div>
            }

            {audio_player_b!==null &&

             <div className="announcement testtimevideo">
             {audio_player_b}
             </div>

            }

            {download_file_b?download_file_b:''}
            </div>


           {dt3.pa_instruction_b!=="" &&

              <div className="comp_txt">
              <div className="editortxt edtxttop">
              <span className="ddcomp" dangerouslySetInnerHTML={{ __html:dt3.pa_instruction_b?dt3.pa_instruction_b:''}} />
              </div>
              </div>
           }

           </div>
           <div className="report-content">


                     <h3>Report B</h3>

                      <span dangerouslySetInnerHTML={{ __html:dt3Answer.option_b_answer?dt3Answer.option_b_answer:''}} />



                  {(dt3Answer.report_file_b!==null && dt3Answer.report_file_b!=="")?
                   <div className="mentermailrow">
                   <div className="mentermaillft"><h3>File</h3></div>
                   <div className="mentermailrgt">
                   <a href={`${Config.domainUrl}download/dt3_report_file/${dt3Answer.report_file_b}`} className="redlnk" target="_blank" style={{float:'left',marginTop:0}} title={`Download file`}>Download file
                   </a>
                   </div>
                   </div>:""}

          </div>

         </div>



         <div className="graybox_test" style={{display:this.state.instructionBlockC,float:'left'}}>
         <div className="graybox-inner">
          <div className="instruction_top">
          Option C
          </div>


           <div className="instruction_txt coursewrkvideo">
           {video_player_c!==null &&
            <div className="announcement testtimevideo">
            {video_player_c}
            </div>
           }



           {audio_player_c!==null &&

            <div className="announcement testtimevideo">
            {audio_player_c}
            </div>

           }

           {download_file_c?download_file_c:''}
           </div>


          {dt3.pa_instruction_c!=="" &&

             <div className="comp_txt">
             <div className="editortxt edtxttop">
             <span className="ddcomp" dangerouslySetInnerHTML={{ __html:dt3.pa_instruction_c?dt3.pa_instruction_c:''}} />
             </div>
             </div>
          }
          </div>
           <div className="report-content">


           <h3>Report C</h3>

           <span dangerouslySetInnerHTML={{ __html:dt3Answer.option_c_answer?dt3Answer.option_c_answer:''}} />



           {(dt3Answer.report_file_c!==null && dt3Answer.report_file_c!=="")?
           <div className="mentermailrow">
           <div className="mentermaillft"><h3>File</h3></div>
           <div className="mentermailrgt">
           <a href={`${Config.domainUrl}download/dt3_report_file/${dt3Answer.report_file_c}`} className="redlnk" target="_blank" style={{float:'left',marginTop:0}} title={`Download file`}>Download file
           </a>
           </div>
           </div>:""}

           </div>
         </div>




           <div style={{float:'right'}}>
                <input type="button" onClick={(e)=>this.backToComponentList()} name="btnsubmit" value="Continue" className="button_org" alt="Continue" title="Continue"/>
                </div>

            </div>

          </div>


       </div>
      </section>
      </section>
      </section>
      </div>
     </div>
    );
  }

}

function mapStateToProps(state, ownProps) {      
  
  return {
    actionGoal: state.actionGoal
  };
}

function mapDispatchToProps(dispatch) {
      
  return  bindActionCreators({getLearningRoom,getActiongoalAction}, dispatch);
 
}

export default connect(mapStateToProps,mapDispatchToProps)(Descriptivetask3);



// WEBPACK FOOTER //
// ./src/lr_dlr_components/Descriptivetask3.js